// extracted by mini-css-extract-plugin
export var CTA = "someGuideTemplate-module--CTA--131df";
export var CTAText = "someGuideTemplate-module--CTAText--aeec2";
export var IconWrapper = "someGuideTemplate-module--IconWrapper--df2b2";
export var NoMargin = "someGuideTemplate-module--NoMargin--c24e2";
export var ScrollDetector = "someGuideTemplate-module--ScrollDetector--e1a15";
export var Section = "someGuideTemplate-module--Section--5b7f1";
export var StickyMenu = "someGuideTemplate-module--StickyMenu--30121";
export var Subtitle = "someGuideTemplate-module--Subtitle--3a200";
export var a1 = "someGuideTemplate-module--a1--2810e";
export var a2 = "someGuideTemplate-module--a2--f2642";
export var a3 = "someGuideTemplate-module--a3--4cef4";
export var active = "someGuideTemplate-module--active--97ee7";
export var arrow = "someGuideTemplate-module--arrow--b8703";
export var arrows = "someGuideTemplate-module--arrows--94c36";
export var contentWrapper = "someGuideTemplate-module--contentWrapper--f7a13";
export var dark = "someGuideTemplate-module--dark--41cdd";
export var description = "someGuideTemplate-module--description--5eb30";
export var expandedArrow = "someGuideTemplate-module--expandedArrow--e6625";
export var expandedGuideSectionTitle = "someGuideTemplate-module--expandedGuideSectionTitle--f52d6";
export var expandedIconWrapper = "someGuideTemplate-module--expandedIconWrapper--2e8f3";
export var fadeOut = "someGuideTemplate-module--fadeOut--81d5d";
export var guideSection = "someGuideTemplate-module--guideSection--fb12a";
export var guideSectionTitle = "someGuideTemplate-module--guideSectionTitle--7636f";
export var header = "someGuideTemplate-module--header--28058";
export var iconWrapper = "someGuideTemplate-module--iconWrapper--45da6";
export var sections = "someGuideTemplate-module--sections--4a373";